const CONSTANTS = {
	// Login request 
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGOUT_REQUEST: 'LOGOUT_REQUEST',
	LOGIN_FAILURE: 'LOGIN_FAILURE',

	// Diamond Parking basic informatio page (facility)
	GET_FACILITY_REQUEST: 'GET_FACILITY_REQUEST',
	GET_FACILITY_SUCCESS: 'GET_FACILITY__SUCCESS',
	GET_FACILITY_FAILURE: 'GET_FACILITY_FAILURE',

	// Diamond Parking basic informatio page (facility)
	BOOKING_REQUEST: 'BOOKING_REQUEST',
	BOOKING_SUCCESS: 'BOOKING__SUCCESS',
	BOOKING_FAILURE: 'BOOKING_FAILURE',

	// RATE LIST
	GET_PERMIT_RATE_LIST_REQUEST: 'GET_PERMIT_RATE_LIST_REQUEST',
	GET_PERMIT_RATE_LIST_SUCCESS: 'GET_PERMIT_RATE_LIST_SUCCESS',
	GET_PERMIT_RATE_LIST_FAILURE: 'GET_PERMIT_RATE_LIST_FAILURE',

	// PRO RATE LIST
	GET_PRO_RATE_LIST_REQUEST: 'GET_PRO_RATE_LIST_REQUEST',
	GET_PRO_RATE_LIST_SUCCESS: 'GET_PRO_RATE_LIST_SUCCESS',
	GET_PRO_RATE_LIST_FAILURE: 'GET_PRO_RATE_LIST_FAILURE',


	// permit list constant 
	GET_PERMIT_LIST_REQUEST: 'GET_PERMIT_LIST_REQUEST',
	GET_PERMIT_LIST_SUCCESS: 'GET_PERMIT_LIST_SUCCESS',
	GET_PERMIT_LIST_FAILURE: 'GET_PERMIT_LIST_FAILURE',

	// permit Active list constant 
	GET_ACTIVE_PERMIT_LIST_REQUEST: 'GET_ACTIVE_PERMIT_LIST_REQUEST',
	GET_ACTIVE_PERMIT_LIST_SUCCESS: 'GET_ACTIVE_PERMIT_LIST_SUCCESS',
	GET_ACTIVE_PERMIT_LIST_FAILURE: 'GET_ACTIVE_PERMIT_LIST_FAILURE',

	// get vehicle list constant
	GET_VEHICLE_LIST_REQUEST: 'GET_VEHICLE_LIST_REQUEST',
	GET_VEHICLE_LIST_SUCCESS: 'GET_VEHICLE_LIST_SUCCESS',
	GET_VEHICLE_LIST_FAILURE: 'GET_VEHICLE_LIST_FAILURE',

	// get check in list constant
	GET_CHECK_IN_LIST_REQUEST: 'GET_CHECK_IN_LIST_REQUEST',
	GET_CHECK_IN_LIST_SUCCESS: 'GET_CHECK_IN_LIST_SUCCESS',
	GET_CHECK_IN_LIST_FAILURE: 'GET_CHECK_IN_LIST_FAILURE',

	// post vehicle list constant
	POST_VEHICLE_LIST_REQUEST: 'POST_VEHICLE_LIST_REQUEST',
	POST_VEHICLE_LIST_SUCCESS: 'POST_VEHICLE_LIST_SUCCESS',
	POST_VEHICLE_LIST_FAILURE: 'POST_VEHICLE_LIST_FAILURE',

	// Delete vehicle list constant
	DELETE_VEHICLE_ITEM_REQUEST: 'DELETE_VEHICLE_ITEM_REQUEST',
	DELETE_VEHICLE_ITEM_SUCCESS: 'DELETE_VEHICLE_ITEM_SUCCESS',
	DELETE_VEHICLE_ITEM_FAILURE: 'DELETE_VEHICLE_ITEM_FAILURE',
	// UPDATE WAITING LIST
	UPDATE_WAITING_LIST_REQUEST: 'UPDATE_WAITING_LIST_REQUEST',
	UPDATE_WAITING_LIST_SUCCESS: 'UPDATE_WAITING_LIST_SUCCESS',
	UPDATE_WAITING_LIST_FAILURE: 'UPDATE_WAITING_LIST_FAILURE',

	//get vehicle Model list
	GET_VEHICLE_MODEL_REQUEST: 'GET_VEHICLE_MODEL_REQUEST',
	GET_VEHICLE_MODEL_SUCCESS: 'GET_VEHICLE_MODEL_SUCCESS',
	GET_VEHICLE_MODEL_FAILURE: 'GET_VEHICLE_MODEL_FAILURE',


	// card list constant 
	GET_CARD_LIST_REQUEST: 'GET_CARD_LIST_REQUEST',
	GET_CARD_LIST_SUCCESS: 'GET_CARD_LIST_SUCCESS',
	GET_CARD_LIST_FAILURE: 'GET_CARD_LIST_FAILURE',

	CREATE_CARD_REQUEST: 'CREATE_CARD_REQUEST',
	CREATE_CARD_SUCCESS: 'CREATE_CARD_SUCCESS',
	CREATE_CARD_FAILURE: 'CREATE_CARD_FAILURE',

	UPDATE_CARD_REQUEST: 'UPDATE_CARD_REQUEST',
	UPDATE_CARD_SUCCESS: 'UPDATE_CARD_SUCCESS',
	UPDATE_CARD_FAILURE: 'UPDATE_CARD_FAILURE',

	CARD_DELETE_REQUEST: 'CARD_DELETE_REQUEST',
	CARD_DELETE_SUCCESS: 'CARD_DELETE_SUCCESS',
	CARD_DELETE_FAILED: 'CARD_DELETE_FAILED',
	//  update user profile 
	UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
	UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
	UPDATE_USER_PROFILE_FAILURE: 'UPDATE_USER_PROFILE_FAILURE',

	//  get user profile 
	GET_USER_PROFILE_REQUEST: 'GET_USER_PROFILE_REQUEST',
	GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
	GET_USER_PROFILE_FAILURE: 'GET_USER_PROFILE_FAILURE',

	// MODAL CONSTANTS
	OPEN_MODAL: 'OPEN_MODAL',

	//  get Pass List
	GET_PASS_LIST_REQUEST: 'GET_PASS_LIST_REQUEST',
	GET_PASS_LIST_SUCCESS: 'GET_PASS_LIST_SUCCESS',
	GET_PASS_LIST_FAILURE: 'GET_PASS_LIST_FAILURE',

	// Reset Password
	POST_RESET_PASSWORD_REQUEST: 'POST_RESET_PASSWORD_REQUEST',
	POST_RESET_PASSWORD_SUCCESS: 'POST_RESET_PASSWORD_SUCCESS',
	POST_RESET_PASSWORD_FAILURE: 'POST_RESET_PASSWORD_FAILURE',

	//passList constants
	FACILITY_PASS_LIST_REQUEST: 'FACILITY_PASS_LIST_REQUEST',
	FACILITY_PASS_LIST_SUCCESS: 'FACILITY_PASS_LIST_SUCCESS',
	FACILITY_PASS_LIST_FAILED: 'FACILITY_PASS_LIST_FAILED',

	// Diamond Parking basic informatio page (facility)
	PASS_BOOKING_REQUEST: 'PASS_BOOKING_REQUEST',
	PASS_BOOKING_SUCCESS: 'PASS_BOOKING__SUCCESS',
	PASS_BOOKING_FAILURE: 'PASS_BOOKING_FAILURE',

	//PAYMENT ACTION CONSTANTS
	PAYMENT_INITIAL_REQUEST: 'PAYMENT_INITIAL_REQUEST',
	PAYMENT_INITIAL_SUCCESS: 'PAYMENT_INITIAL_SUCCESS',
	PAYMENT_INITIAL_FAILURE: 'PAYMENT_INITIAL_FAILURE',


	//booking before payment ACTION CONSTANTS
	BEFORE_PAYMENT_INITIAL_REQUEST: 'BEFORE_PAYMENT_INITIAL_REQUEST',
	BEFORE_PAYMENT_INITIAL_SUCCESS: 'BEFORE_PAYMENT_INITIAL_SUCCESS',
	BEFORE_PAYMENT_INITIAL_FAILURE: 'BEFORE_PAYMENT_INITIAL_FAILURE',

	//booking after payment ACTION CONSTANTS
	AFTER_PAYMENT_INITIAL_REQUEST: 'AFTER_PAYMENT_INITIAL_REQUEST',
	AFTER_PAYMENT_INITIAL_SUCCESS: 'AFTER_PAYMENT_INITIAL_SUCCESS',
	AFTER_PAYMENT_INITIAL_FAILURE: 'AFTER_PAYMENT_INITIAL_FAILURE',
	// Pass purchage

	//PAYMENT ACTION CONSTANTS
	PASS_PAYMENT_INITIAL_REQUEST: 'PASS_PAYMENT_INITIAL_REQUEST',
	PASS_PAYMENT_INITIAL_SUCCESS: 'PASS_PAYMENT_INITIAL_SUCCESS',
	PASS_PAYMENT_INITIAL_FAILURE: 'PASS_PAYMENT_INITIAL_FAILURE',


	//booking before payment ACTION CONSTANTS
	BEFORE_PASS_PAYMENT_INITIAL_REQUEST: 'BEFORE_PASS_PAYMENT_INITIAL_REQUEST',
	BEFORE_PASS_PAYMENT_INITIAL_SUCCESS: 'BEFORE_PASS_PAYMENT_INITIAL_SUCCESS',
	BEFORE_PASS_PAYMENT_INITIAL_FAILURE: 'BEFORE_PASS_PAYMENT_INITIAL_FAILURE',

	//booking after payment ACTION CONSTANTS
	AFTER_PASS_PAYMENT_INITIAL_REQUEST: 'AFTER_PASS_PAYMENT_INITIAL_REQUEST',
	AFTER_PASS_PAYMENT_INITIAL_SUCCESS: 'AFTER_PASS_PAYMENT_INITIAL_SUCCESS',
	AFTER_PASS_PAYMENT_INITIAL_FAILURE: 'AFTER_PAYMENT_INITIAL_FAILURE',


	//  get user Data 
	GET_USER_DATA_REQUEST: 'GET_USER_DATA_REQUEST',
	GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
	GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',


	// booking history

	GET_BOOKING_HISTORY_REQUEST: 'GET_BOOKING_HISTORY_REQUEST',
	GET_BOOKING_HISTORY_SUCCESS: 'GET_BOOKING_HISTORY_SUCCESS',
	GET_BOOKING_HISTORY_FAILURE: 'GET_BOOKING_HISTORY_FAILURE',

	// get ticket details
	GET_TICKET_LIST_REQUEST: 'GET_TICKET_LIST_REQUEST',
	GET_TICKET_LIST_SUCCESS: 'GET_TICKET_LIST_SUCCESS',
	GET_TICKET_LIST_FAILURE: 'GET_TICKET_LIST_FAILURE',

	// get ticket details
	GET_TICKET_DETAILS_REQUEST: 'GET_TICKET_DETAILS_REQUEST',
	GET_TICKET_DETAILS_SUCCESS: 'GET_TICKET_DETAILS_SUCCESS',
	GET_TICKET_DETAILS_FAILURE: 'GET_TICKET_DETAILS_FAILURE',

	// download ticket request 
	DOWNLOAD_TICKET_REQUEST: 'DOWNLOAD_TICKET_REQUEST',
	DOWNLOAD_TICKET_SUCCESS: 'DOWNLOAD_TICKET_SUCCESS',
	DOWNLOAD_TICKET_FAILURE: 'DOWNLOAD_TICKET_FAILURE',

	// get facity
	GET_FACILTY_REQUEST: 'GET_FACILTY_REQUEST',
	GET_FACILTY_SUCCESS: 'GET_FACILTY_SUCCESS',
	GET_FACILTY_FAILURE: 'GET_FACILTY_FAILURE',

	// payment Card Post
	POST_CARD_PAYMENT_REQUEST: 'POST_CARD_PAYMENT_REQUEST',
	POST_CARD_PAYMENT_SUCCESS: 'POST_CARD_PAYMENT_SUCCESS',
	POST_CARD_PAYMENT_FAILURE: 'POST_CARD_PAYMENT_FAILURE',

	END_PARKING_REQUEST: 'END_PARKING_REQUEST',
	END_PARKING_SUCCESS: 'END_PARKING_SUCCESS',
	END_PARKING_FAILURE: 'END_PARKING_FAILURE',


	EXTEND_CARD_DETAILS_REQUEST: 'EXTEND_CARD_DETAILS_REQUEST',
	EXTEND_CARD_DETAILS_SUCCESS: 'EXTEND_CARD_DETAILS_SUCCESS',
	EXTEND_CARD_DETAILS_FAILURE: 'EXTEND_CARD_DETAILS_FAILURE',

	EXTEND_CARD_HOUR_REQUEST: 'EXTEND_CARD_HOUR_REQUEST',
	EXTEND_CARD_HOUR_SUCCESS: 'EXTEND_CARD_HOUR_SUCCESS',
	EXTEND_CARD_HOUR_FAILURE: 'EXTEND_CARD_HOUR_FAILURE',

	// for sing-up
	SINGUP_REQUEST: 'SINGUP_REQUEST',
	SINGUP_SUCCESS: 'SINGUP_SUCCESS',
	SINGUP_FAILURE: 'SINGUP_FAILURE',

	// PASS DETAILS
	PASS_DETAILS_REQUEST: 'PASS_DETAILS_REQUEST',
	PASS_DETAILS_SUCCESS: 'PASS_DETAILS_SUCCESS',
	PASS_DETAILS_FAILURE: 'PASS_DETAILS_FAILURE',

	// PERMIT DETAILS
	PERMIT_DETAILS_REQUEST: 'PERMIT_DETAILS_REQUEST',
	PERMIT_DETAILS_SUCCESS: 'PERMIT_DETAILS_SUCCESS',
	PERMIT_DETAILS_FAILURE: 'PERMIT_DETAILS_FAILURE',

	// promoCode request 
	EXTEND_TICKET_LIST_REQUEST: 'EXTEND_TICKET_LIST_REQUEST',
	EXTEND_TICKET_LIST_SUCCESS: 'EXTEND_TICKET_LIST_SUCCESS',
	EXTEND_TICKET_LIST_FAILURE: 'EXTEND_TICKET_LIST_FAILURE',

	// send email for forgot password request
	SEND_EMAIL_RESET_PASSWORD_REQUEST: 'SEND_EMAIL_RESET_PASSWORD_REQUEST',
	SEND_EMAIL_RESET_PASSWORD_SUCCESS: 'SEND_EMAIL_RESET_PASSWORD_SUCCESS',
	SEND_EMAIL_RESET_PASSWORD_FAILURE: 'SEND_EMAIL_RESET_PASSWORD_FAILURE',

	//booking permit token payment ACTION CONSTANTS
	PERMIT_TOKEN_PAYMENT_REQUEST: 'PERMIT_TOKEN_PAYMENT_REQUEST',
	PERMIT_TOKEN_PAYMENT_SUCCESS: 'PERMIT_TOKEN_PAYMENT_SUCCESS',
	PERMIT_TOKEN_PAYMENT_FAILURE: 'PERMIT_TOKEN_PAYMENT_FAILURE',


	//booking permit token payment ACTION CONSTANTS
	PASS_TOKEN_PAYMENT_REQUEST: 'PASS_TOKEN_PAYMENT_REQUEST',
	PASS_TOKEN_PAYMENT_SUCCESS: 'PASS_TOKEN_PAYMENT_SUCCESS',
	PASS_TOKEN_PAYMENT_FAILURE: 'PASS_TOKEN_PAYMENT_FAILURE',
	//book reservation 
	// user details request 
	USER_DETAILS_REQUEST: 'USER_DETAILS_REQUEST',
	USER_DETAILS_SUCCESS: 'USER_DETAILS_SUCCESS',
	USER_DETAILS_FAILURE: 'USER_DETAILS_FAILURE',
	// GET PARTNER DETAILS
	GET_PARTNER_DETAILS_BY_SLUG_REQUEST: 'GET_PARTNER_DETAILS_BY_SLUG_REQUEST',
	GET_PARTNER_DETAILS_BY_SLUG_SUCCESS: 'GET_PARTNER_DETAILS_BY_SLUG_SUCCESS',
	GET_PARTNER_DETAILS_BY_SLUG_FAILURE: 'GET_PARTNER_DETAILS_BY_SLUG_FAILURE',

	// GET PRICE RESERVATION
	GET_RESERVATION_PRICE_REQUEST: 'GET_RESERVATION_PRICE_REQUEST',
	GET_RESERVATION_PRICE_SUCCESS: 'GET_RESERVATION_PRICE_SUCCESS',
	GET_RESERVATION_PRICE_FAILURE: 'GET_RESERVATION_PRICE_FAILURE',

	// APPLY PROCODE
	GET_RESERVATION_PROMO_CODE_REQUEST: 'GET_RESERVATION_PROMO_CODE_REQUEST',
	GET_RESERVATION_PROMO_CODE_SUCCESS: 'GET_RESERVATION_PROMO_CODE_SUCCESS',
	GET_RESERVATION_PROMO_CODE_FAILURE: 'GET_RESERVATION_PROMO_CODE_FAILURE',

	// RESERVATION
	SAVE_RESERVATION_REQUEST: 'SAVE_RESERVATION_REQUEST',
	SAVE_RESERVATION_SUCCESS: 'SAVE_RESERVATION_SUCCESS',
	SAVE_RESERVATION_FAILURE: 'SAVE_RESERVATION_FAILURE',

	// PURCHASE PERMIT
	PERMIT_PURCHASE_REQUEST: 'PERMIT_PURCHASE_REQUEST',
	PERMIT_PURCHASE_SUCCESS: 'PERMIT_PURCHASE_SUCCESS',
	PERMIT_PURCHASE_FAILURE: 'PERMIT_PURCHASE_FAILURE',

	// RESET PASSWORD
	RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

	// CANCEL PERMIT
	CANCEL_PERMIT_REQUEST: 'CANCEL_PERMIT_REQUEST',
	CANCEL_PERMIT_SUCCESS: 'CANCEL_PERMIT_SUCCESS',
	CANCEL_PERMIT_FAILURE: 'CANCEL_PERMIT_FAILURE',

	// GET Cruise Line
	GET_CRUISE_LINE_REQUEST: 'GET_CRUISE_LINE_REQUEST',
	GET_CRUISE_LINE_SUCCESS: 'GET_CRUISE_LINE_SUCCESS',
	GET_CRUISE_LINE_FAILURE: 'GET_CRUISE_LINE_FAILURE',

	//  for the Booking History Edit Data 
	GET_BOOKING_ID_REQUEST: 'GET_BOOKING_ID_REQUEST',
	GET_BOOKING_ID_SUCCESS: 'GET_BOOKING_ID_SUCCESS',
	GET_BOOKING_ID_FAILURE: 'GET_BOOKING_ID_FAILURE',
	// get vehicle  constant
	GET_VEHICLE_REQUEST: 'GET_VEHICLE_REQUEST',
	GET_VEHICLE_SUCCESS: 'GET_VEHICLE_SUCCESS',
	GET_VEHICLE_FAILURE: 'GET_VEHICLE_FAILURE',

	// get Country Data
	GET_COUNTRY_REQUEST: 'GET_COUNTRY_REQUEST',
	GET_COUNTRY_SUCCESS: 'GET_COUNTRY_SUCCESS',
	GET_COUNTRY_FAILURE: 'GET_COUNTRY_FAILURE',

	// cancel ticket
	GET_CANCELBOOKING_REQUEST: 'GET_CANCELBOOKING_REQUEST',
	GET_CANCELBOOKING_SUCCESS: 'GET_CANCELBOOKING_SUCCESS',
	GET_CANCELBOOKING_FAILURE: 'GET_CANCELBOOKING_FAILURE',

	// PERMIT TYPE LIST
	GET_PERMIT_QR_REQUEST: 'GET_PERMIT_QR_REQUEST',
	GET_PERMIT_QR_SUCCESS: 'GET_PERMIT_QR_SUCCESS',
	GET_PERMIT_QR_FAILURE: 'GET_PERMIT_QR_FAILURE',

	// permit request list constant 
	GET_PERMIT_REQUEST_LIST_REQUEST: 'GET_PERMIT_REQUEST_LIST_REQUEST',
	GET_PERMIT_REQUEST_LIST_SUCCESS: 'GET_PERMIT_REQUEST_LIST_SUCCESS',
	GET_PERMIT_REQUEST_LIST_FAILURE: 'GET_PERMIT_REQUEST_LIST_FAILURE',
	// Invoice Constants

	INVOICE_PERMIT_LIST_REQUEST: 'INVOICE_PERMIT_LIST_REQUEST',
	INVOICE_PERMIT_LIST_SUCCESS: 'INVOICE_PERMIT_LIST_SUCCESS',
	INVOICE_PERMIT_LIST_FAILURE: 'INVOICE_PERMIT_LIST_FAILURE',

	DOWNLOAD_INVOICE_REQUEST: 'DOWNLOAD_INVOICE_REQUEST',
	DOWNLOAD_INVOICE_SUCCESS: 'DOWNLOAD_INVOICE_SUCCESS',
	DOWNLOAD_INVOICE_FAILURE: 'DOWNLOAD_INVOICE_FAILURE',

	// Permit Renew api const
	PERMIT_RENEW_REQUEST: 'PERMIT_RENEW_REQUEST',
	PERMIT_RENEW_SUCCESS: 'PERMIT_RENEW_SUCCESS',
	PERMIT_RENEW_FAILURE: 'PERMIT_RENEW_FAILURE',

	// PURCHASE PERMIT
	USER_PERMIT_DETAILS_REQUEST: 'USER_PERMIT_DETAILS_REQUEST',
	USER_PERMIT_DETAILS_SUCCESS: 'USER_PERMIT_DETAILS_SUCCESS',
	USER_PERMIT_DETAILS_FAILURE: 'USER_PERMIT_DETAILS_FAILURE',

	PUT_MOBILE_NUMBER_REQUEST: 'PUT_MOBILE_NUMBER_REQUEST',
	PUT_MOBILE_NUMBER_SUCCESS: 'PUT_MOBILE_NUMBER_SUCCESS',
	PUT_MOBILE_NUMBER_FAILURE: 'PUT_MOBILE_NUMBER_FAILURE',

	// Permit Category LIST
	GET_PERMIT_CATEGORY_LIST_REQUEST: 'GET_PERMIT_CATEGORY_LIST_REQUEST',
	GET_PERMIT_CATEGORY_LIST_SUCCESS: 'GET_PERMIT_CATEGORY_LIST_SUCCESS',
	GET_PERMIT_CATEGORY_LIST_FAILURE: 'GET_PERMIT_CATEGORY_LIST_FAILURE',

	GET_PERMIT_CATEGORY_SERVICE_REQUEST: 'GET_PERMIT_CATEGORY_SERVICE_REQUEST',
	GET_PERMIT_CATEGORY_SERVICE_SUCCESS: 'GET_PERMIT_CATEGORY_SERVICE_SUCCESS',
	GET_PERMIT_CATEGORY_SERVICE_FAILURE: 'GET_PERMIT_CATEGORY_SERVICE_FAILURE',
	// GET WARNING DETAIL
	GET_WARNING_DETAIL_REQUEST: 'GET_WARNING_DETAIL_REQUEST',
	GET_WARNING_DETAIL_SUCCESS: 'GET_WARNING_DETAIL_SUCCESS',
	GET_WARNING_DETAIL_FAILURE: 'GET_WARNING_DETAIL_FAILURE',

	// GET WARNING DETAIL
	GET_RATE_FACILITY_REQUEST: 'GET_RATE_FACILITY_REQUEST',
	GET_RATE_FACILITY_SUCCESS: 'GET_RATE_FACILITY_SUCCESS',
	GET_RATE_FACILITY_FAILURE: 'GET_RATE_FACILITY_FAILURE',

	// GET WARNING DETAIL
	GET_USER_VALID_CHECK_REQUEST: 'GET_USER_VALID_CHECK_REQUEST',
	GET_USER_VALID_CHECK_SUCCESS: 'GET_USER_VALID_CHECK_SUCCESS',
	GET_USER_VALID_CHECK_FAILURE: 'GET_USER_VALID_CHECK_FAILURE',

	// GET_FACILITY_RATE_REQUEST

	GET_FACILITY_RATE_REQUEST: 'GET_FACILITY_RATE_REQUEST',
	GET_FACILITY_RATE_SUCCESS: 'GET_FACILITY_RATE_SUCCESS',
	GET_FACILITY_RATE_FAILURE: 'GET_FACILITY_RATE_FAILURE',

	// Add Service
	PERMIT_ADDSERVICE_REQUEST: 'PERMIT_ADDSERVICE_REQUEST',
	PERMIT_ADDSERVICE_SUCCESS: 'PERMIT_ADDSERVICE_SUCCESS',
	PERMIT_ADDSERVICE_FAILURE: 'PERMIT_ADDSERVICE_FAILURE',

	// GET_Inventory update

	INVENTORY_UPDATE_REQUEST: 'INVENTORY_UPDATE_REQUEST',
	INVENTORY_UPDATE_SUCCESS: 'INVENTORY_UPDATE_SUCCESS',
	INVENTORY_UPDATE_FAILURE: 'INVENTORY_UPDATE_FAILURE',
	PERMIT_PURCHAGE_CLICK: 'PERMIT_PURCHAGE_CLICK',



	CARD_UPDATE_REQUEST: 'CARD_UPDATE_REQUEST',
	CARD_UPDATE_SUCCESS: 'CARD_UPDATE_SUCCESS',
	CARD_UPDATE_FAILED: 'CARD_UPDATE_FAILED',

	GET_USER_EMAILID_CHECK_REQUEST: 'GET_USER_EMAILID_CHECK_REQUEST',
	GET_USER_EMAILID_CHECK_SUCCESS: 'GET_USER_EMAILID_CHECK_SUCCESS',
	GET_USER_EMAILID_CHECK_FAILURE: 'GET_USER_EMAILID_CHECK_FAILURE',

	PASS_DOWNLOAD_REQUEST: 'PASS_DOWNLOAD_REQUEST',
	PASS_DOWNLOAD_SUCCESS: 'PASS_DOWNLOAD_SUCCESS',
	PASS_DOWNLOAD_FAILURE: 'PASS_DOWNLOAD_FAILURE',

	// GET DOCUMENT TYPES
	GET_DOCUMENT_TYPES_REQUEST: 'GET_DOCUMENT_TYPES_REQUEST',
	GET_DOCUMENT_TYPES_SUCCESS: 'GET_DOCUMENT_TYPES_SUCCESS',
	GET_DOCUMENT_TYPES_FAILURE: 'GET_DOCUMENT_TYPES_FAILURE',

	// GET PARKING TYPES
	GET_PARKING_TYPES_REQUEST: 'GET_PARKING_TYPES_REQUEST',
	GET_PARKING_TYPES_SUCCESS: 'GET_PARKING_TYPES_SUCCESS',
	GET_PARKING_TYPES_FAILURE: 'GET_PARKING_TYPES_FAILURE',

	// GET VALIDATION CODES
	GET_VALIDATION_CODES_REQUEST: 'GET_VALIDATION_CODES_REQUEST',
	GET_VALIDATION_CODES_SUCCESS: 'GET_VALIDATION_CODES_SUCCESS',
	GET_VALIDATION_CODES_FAILURE: 'GET_VALIDATION_CODES_FAILURE',

	// EOS-740 FIND RESERVATION
	GET_FIND_RESERVATION_REQUEST: 'GET_FIND_RESERVATION_REQUEST',
	GET_FIND_RESERVATION_SUCCESS: 'GET_FIND_RESERVATION_SUCCESS',
	GET_FIND_RESERVATION_FAILURE: 'GET_FIND_RESERVATION_FAILURE',

	// EOS-852 keycard replacement
	KEYCARD_REPLACEMENT_REQUEST: 'KEYCARD_REPLACEMENT_REQUEST',
	KEYCARD_REPLACEMENT_SUCCESS: 'KEYCARD_REPLACEMENT_SUCCESS',
	KEYCARD_REPLACEMENT_FAILURE: 'KEYCARD_REPLACEMENT_FAILURE',

	KEYCARD_REPLACEMENT_DETAILS_REQUEST: 'KEYCARD_REPLACEMENT_DETAILS_REQUEST',
	KEYCARD_REPLACEMENT_DETAILS_SUCCESS: 'KEYCARD_REPLACEMENT_DETAILS_SUCCESS',
	KEYCARD_REPLACEMENT_DETAILS_FAILURE: 'KEYCARD_REPLACEMENT_DETAILS_FAILURE',

	// OTP
	SEND_OTP_REQUEST: 'SEND_OTP_REQUEST',
	SEND_OTP_SUCCESS: 'SEND_OTP_SUCCESS',
	SEND_OTP_FAILURE: 'SEND_OTP_FAILURE',
	VERIFY_OTP_REQUEST: 'VERIFY_OTP_REQUEST',
	VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
	VERIFY_OTP_FAILURE: 'VERIFY_OTP_FAILURE',

	// EOS-973
	UNEXPECTED_ERROR: 'UNEXPECTED ERROR',
	// EOS-973

	// EOS-2427
	PERMIT_ID_DETAILS_REQUEST: 'PERMIT_ID_DETAILS_REQUEST',
	PERMIT_ID_DETAILS_SUCCESS: 'PERMIT_ID_DETAILS_SUCCESS',
	PERMIT_ID_DETAILS_FAILURE: 'PERMIT_ID_DETAILS_FAILURE',
	PERMIT_UPDATE_REQUEST: 'PERMIT_UPDATE_REQUEST',
	PERMIT_UPDATE_SUCCESS: 'PERMIT_UPDATE_SUCCESS',
	PERMIT_UPDATE_FAILURE: 'PERMIT_UPDATE_FAILURE',


}
export default CONSTANTS
